import { render, staticRenderFns } from "./pl-time.vue?vue&type=template&id=053aa979&"
import script from "./pl-time.vue?vue&type=script&lang=js&"
export * from "./pl-time.vue?vue&type=script&lang=js&"
import style0 from "./pl-time.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports